<div class="layout">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
